import React from 'react';

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-8 border-b pb-4">Datenschutzerklärung</h1>
          
          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-blue-700 mb-4">1. Datenschutz auf einen Blick</h2>
              <h3 className="font-bold mb-2">Allgemeine Hinweise</h3>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-700 mb-4">2. Verantwortlicher</h2>
              <p className="mb-2 font-semibold text-gray-800">Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
              <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-blue-600">
                <p className="font-bold">Kai Alexander Bewig</p>
                <p>Schimmelstraße 6</p>
                <p>89415 Lauingen</p>
                <p className="mt-2">E-Mail: kai@bewig.de</p>
                <p>Telefon: 09072-718110</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-700 mb-4">3. Datenerfassung auf dieser Website</h2>
              <h3 className="font-bold mb-2 text-gray-800">Server-Log-Dateien</h3>
              <p className="mb-4">
                Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-1">
                <li>Browsertyp und Browserversion</li>
                <li>Verwendetes Betriebssystem</li>
                <li>Referrer URL</li>
                <li>Hostname des zugreifenden Rechners</li>
                <li>Uhrzeit der Serveranfrage</li>
                <li>IP-Adresse</li>
              </ul>
              <p>
                Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der technisch fehlerfreien Darstellung und Optimierung der Website).
              </p>

              <h3 className="font-bold mb-2 mt-6 text-gray-800">Kontaktformular / E-Mail-Kontakt</h3>
              <p>
                Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-700 mb-4">4. Ihre Rechte</h2>
              <p className="mb-4">
                Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><span className="font-semibold">Auskunft (Art. 15 DSGVO):</span> Sie können Informationen über Ihre von uns verarbeiteten personenbezogenen Daten verlangen.</li>
                <li><span className="font-semibold">Berichtigung (Art. 16 DSGVO):</span> Sie können die Berichtigung unrichtiger Daten verlangen.</li>
                <li><span className="font-semibold">Löschung (Art. 17 DSGVO):</span> Sie können die Löschung Ihrer bei uns gespeicherten Daten verlangen.</li>
                <li><span className="font-semibold">Widerspruch (Art. 21 DSGVO):</span> Sie können der Verarbeitung Ihrer Daten widersprechen.</li>
              </ul>
            </section>

            <section className="bg-blue-50 p-6 rounded-lg">
              <h2 className="text-xl font-bold text-blue-800 mb-2">Beschwerderecht</h2>
              <p className="text-blue-700">
                Im Falle von datenschutzrechtlichen Verstößen steht dem Betroffenen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes Bayern.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;